export default __webpack_public_path__ + "static/media/gallery_05.e44150a4.jpg";